import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Redirect, Route } from "react-router-dom";
import { IonApp, IonRouterOutlet, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import HostPage from "./HostPage";
/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";
/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";
import "@dieta-social/shop-widget/style.css";
setupIonicReact();
const App = (config) => (_jsx(IonApp, { children: _jsx(IonReactRouter, { children: _jsxs(IonRouterOutlet, { children: [_jsx(Route, { path: "/", children: _jsx(HostPage, { ...config, basePath: config.basePath ?? "/" }) }), _jsx(Redirect, { to: "/" })] }) }) }));
export default App;
